// Type exports
export * from './types';

// Duplex core is internal and not exported publicly.

// Writable stream (server-side)
export { IframeWritableStream } from './writable-stream';
export { IframeFileWritableStream } from './file-stream';

// Stream error
export { RequestIframeStreamError } from './error';
// Readable stream (client-side)
export { IframeReadableStream } from './readable-stream';
export { IframeFileReadableStream } from './file-stream';

// Type checking utility functions
import { IframeReadableStream } from './readable-stream';
import { IframeFileReadableStream, IframeFileWritableStream } from './file-stream';
import { IframeWritableStream } from './writable-stream';
/**
 * Check if value is an IframeReadableStream
 */
export function isIframeReadableStream(value) {
  return value instanceof IframeReadableStream;
}

/**
 * Check if value is an IframeFileReadableStream (file stream)
 */
export function isIframeFileReadableStream(value) {
  return value instanceof IframeFileReadableStream;
}

/**
 * Check if value is an IframeWritableStream (includes IframeFileWritableStream)
 */
export function isIframeWritableStream(value) {
  return value instanceof IframeWritableStream || value instanceof IframeFileWritableStream;
}

/**
 * Check if value is an IframeFileWritableStream (file writable stream)
 */
export function isIframeFileWritableStream(value) {
  return value instanceof IframeFileWritableStream;
}